import * as React from 'react'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import PathSyllabus from 'components/atomic/organisms/syllabus/path'
import Text from 'components/atomic/atoms/text'
import Icon from 'components/atomic/atoms/icon'

import { Path } from 'types/types'

const Syllabus = (props: Path) => {
    const { t }: I18n = useTranslation()

    return (
        <div>
            <Box mb={4}>
                <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                    <Icon fontSize="small" color="primary" name="helpOutline" />
                    <Text sx={{ textTransform: 'uppercase', fontWeight: 'bold' }} color="primary">
                        {t('path:syllabusSection.label')}
                    </Text>
                </Stack>
                <Text variant="h4">{t('path:syllabusSection.title')}</Text>
            </Box>
            <PathSyllabus pathId={props._id} />
        </div>
    )
}

export default Syllabus
